import React from 'react';

interface ISkeleton {
  height?: string;
  width?: string;
}

const Skeleton = ({ height = '150px', width = '100%' }: ISkeleton) => (
  <div style={{ backgroundColor: '#fafafa', height, width }} />
);

export default Skeleton;
